import { DateTime } from 'luxon';
import { Container } from 'react-bootstrap';

const Footer = () => (
  <footer className="site-footer site-footer-compact">
    <Container>
      <div className="footer-compact-row">
        <div className="footer-compact-brand">
          <div className="footer-lines">
            <div className="footer-title">Knights of Columbus - Council 1056</div>
            <span className="footer-spacer" aria-hidden="true">|</span>
            <div className="footer-sub">21 S. Henry St, Delaware, OH 43015 - St. Mary Parish</div>
          </div>
        </div>
      </div>
      <div className="footer-bottom footer-bottom-compact">
        <span>&copy; {DateTime.now().year} Knights of Columbus Council 1056</span>
      </div>
    </Container>
  </footer>
);

export default Footer;